export default __webpack_public_path__ + "static/media/hero-default-768.e4466241.jpg";